import { Box } from "@mui/system";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

import Text from "./text/Text";
import CustomDivider from "./divider/Divider";

function SettingsMenuComponent({ menu }) {
  return (
    <>
      {menu?.map((item, index) => {
        return (
          <Box key={index} className="settings-section">
            <Box className="setting-section-header">
              <Text className="heading-text" size={18} font="semibold">
                {item?.section}
              </Text>
            </Box>
            <Box className="setting-section-list">
              {item.menus?.map((menu, index) => (
                <>
                  <Box
                    key={"menu_" + index}
                    className="setting-section-conent"
                    onClick={menu?.action || null}
                  >
                    <Box display="flex" alignItems="center">
                      <Box className="setting-section-icon">{menu.icon}</Box>
                      <Text
                        className="default-text"
                        font="medium"
                        size={16}
                        sx={{ marginLeft: "16px" }}
                      >
                        {menu.name}
                      </Text>
                    </Box>
                    <Box display="flex" alignItems="center">
                      {menu?.text && (
                        <Text
                          className="default-text"
                          font="semibold"
                          size={16}
                          sx={{ marginRight: "8px" }}
                        >
                          {menu.text}
                        </Text>
                      )}
                      <KeyboardArrowRightOutlinedIcon
                        sx={{ height: "24px", width: "24px", color: "#848B9E" }}
                      />
                    </Box>
                  </Box>
                  {index < item.menus.length - 1 && (
                    <CustomDivider
                      sx={{
                        margin: "0px 14px 0px 50px",
                        borderColor: "#f0f0f0",
                      }}
                    />
                  )}
                </>
              ))}
            </Box>
          </Box>
        );
      })}
    </>
  );
}

export default SettingsMenuComponent;
